module.exports={
    btn:{
        tips_reelect_btn:"Nytt bilde",
        cancel_btn:"Avbryt",
        tips_continue_dispose:"Oppskalere støttede bilder",
        tips_return:"Nytt bilde",
        tips_upgrade:"Oppgradering",
        tips_yes:"OK",
        delete:"Slett",
        download:"nedlasting",
        upload_image:"Last opp bilde",
        new_image:"Nytt bilde",
        save_all:"Lagre alt",
        cancel:"Avbryter",
        save:"Lagre",
        view_comparison:"Se sammenligning",
        hide_comparison:"Skjul sammenligning",
        previous:"Tidligere",
        next:"Neste",
        continue_download:"Lagre bilder med vannmerker",
        present:"Bruk på dette bildet",
        all_wait:"Bruk på bilder i vente",
        all:"Bruk på alle bilder",
        history:"Historie",
        login:"Logg Inn",
    },
    tips:{
        please_upgrade:"Din nåværende plan støtter ikke opplasting eller oppskalering av bilder i grupper. Oppgrader den for å få flere fordeler.",
        errorlistinfo:"XXX bilder er valgt. XXX bilder støttes, men XXX bilder støttes ikke. Følgende bilder støttes ikke:",
        max:"Overskrid den maksimale bildestørrelsesgrensen på 10 MB!",
        max_size:"Overskrid grensen for maksimal bildesidelengde på 4096 piksler!",
        continue_dispose:"Oppskalere støttede bilder",
        please_multiple:"Vennligst velg forstørrelsen.",
        max_multiple:"* Bildet ditt vil bli forstørret til maksimalt 4K (den lengste siden vil ikke overstige 4096px).",
        title:"Navn",
        reasons:"Grunner",
        upload_type:"Ikke støttet",
        used_up:"Antall lagrede HD-bilder uten vannmerker er brukt opp. Vennligst oppgrader kontoen din. Eller du kan lagre HD-bilder med vannmerker.",
        edit_multiple:"Det er lastet opp flere bilder. Velg bilder du vil endre forstørrelsen på. Etter valg vil disse bildene bli oppskalert igjen til den nye forstørrelsen.",
        download_confirm:"Noen bilder er fortsatt under behandling. Er du sikker på at du vil lagre alle oppskalerte bilder? Når du lagrer det samme bildet gjentatte ganger, blir ikke antall lagrede bilder trukket fra igjen.",
        waiting_save:"Noen bilder er fortsatt under behandling. Vennligst lagre senere.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD-bilde(r)",
        watermarks:"uten vannmerker kan lastes ned for øyeblikket.",
        view_details:"Vis detaljer",
        loading:"Laster inn …",
    },
    content:{
        failed:"Mislyktes",
        completed:"Fullført",
        processing:"Behandling",
        img_processing:"Behandling…",
        img_failed:"Kunne ikke behandle",
        uploading:"Laster opp",
        img_uploading:"Laster opp …",
        wait_upoading:"Venter på å laste opp …",
        waiting:"Venter",
        img_waiting:"Venter…",
        empty:"Tømme",
        magnification:"Forstørrelse:",
        drop:"Eller slipp bildefilen din her for å oppskalere og forbedre!",
        original:"Opprinnelig:",
        output:"Produksjon:",
        img_rendering1:"Bildet ditt har blitt oppskalert.",
        img_rendering2:"Vi jobber med å gjengi bildet av høy kvalitet for forhåndsvisning, vennligst vent...",
        no_watermark:"Etter lagring har bildet ikke noe vannmerke.",
    },
    banner_msg:"Velg en plan for bildeoppskalering",
    monthly:"MÅNEDLIG",
    lifetime:"LIVSTID",
    choose_plan:"Velg planen din basert på antall bilder",
    return_home:"Gratulerer! Du har oppgradert. Gå tilbake til hjemmesiden og bruk dette produktet.",
    congratulations:"Gratulerer! Du har oppgradert. Fordelene er bundet til e-postadressen du la igjen under oppgraderingen. Vennligst bruk kontoen som er registrert eller knyttet til e-postadressen til",
    login_benefits:"logg inn for å bruke fordeler",
    no_registered:". Hvis du ikke har registrert eller knyttet en konto til e-postadressen, vennligst",
    register_account:"bruk e-postadressen for å registrere en konto",
    other_accounts:" eller koble andre kontoer til denne e-postadressen for å bruke fordeler.",
    btn_close:"Lukk",
    free:"Gratis",
    btn_get_started:"Kom i gang",
    // access_to:"Tilgang til",
    upscale_images:"Oppskalere bilder",
    up_to:"Opp til",
    per_image:" per bilde",
    resolution_of:"Opp til oppløsning på",
    default_level:"Oppskalere bilder på standardnivå",
    image_downloads:"2 HD-bildenedlastinger uten vannmerke",
    unlimited_image:"Ubegrenset bildenedlasting med vannmerke",
    SHA256_encryption:"SHA256 krypteringsteknikk",
    mon:"Månedlig",
    images:"Bilder",
    high_resolution:" med høyoppløselig kvalitet",
    tax_incl:"Skatt inkl. mva.",
    image:"bilde",
    secure_checkout:"Sikker utsjekk",
    everything:"Alt i gratis, og",
    upscaling_levels:"Alle oppskaleringsnivåer kan velges",
    unlimited_image_without:"Ubegrenset bildenedlasting uten vannmerke",
    viewable_editing:"Synlig redigeringshistorikk er gyldig for",
    days:" dager",
    high_level:"Høy level",
    priority_processing:" prioritert behandling",
    left:"Livstid",
    resolution:" Vedtak",


    "history_will":"Vil utløpe etter",
    "history.days":"Dager)",
    "history.hours":"timer",
    "expired":"Utløpt",
    "access_to":"Med den gratis prøveversjonen kan du bare",
    "pricing.upload_images":"Last opp bilder",
    "pricing.under":"under",
    "pricing.images":"Bilder",
    "pricing.without_watermark":"uten vannmerke",
    "pricing.process_images":"Behandle bilder opp til",
    "pricing.pixels":"piksler",
    "pricing.enjoy_limited":"Nyt begrensede eksklusive karakterer",
    "pricing.download":"nedlasting",
    "pricing.HD_images":"HD-bilder uten vannmerke",
    "pricing.and_you":"Og du kan lide av",
    "pricing.slow_upscaling":"langsom oppskalering",
    "pricing.lower_priority":"lavere prioritet",
    "pricing.without":"uten vannmerke",
    "pricing.tax":"Avgifter er inkludert i salgsprisen og vil bli beregnet automatisk basert på ditt land og din region. I handlekurven kan du se detaljert avgiftsbeløp. Det endelige betalingsbeløpet skal være det samme som den viste prisen.",
    "pricing.you_can":"Med abonnement kan du",
    "pricing.up_to":"Last opp bilder opptil",
    "pricing.upscale_images":"Oppskalere bilder med",
    "pricing.no_watermark":"ikke noe vannmerke",
    "pricing.enhance":"Forbedre",
    "pricing.or_more":"bilder eller mer",
    "pricing.in_batch":"i batch",
    "pricing.enlarge_images":"Forstørr bildene inn",
    "pricing.and":"og",
    "pricing.times_with":"ganger uten grenser",
    "pricing.enjoy":"Nyt",
    "pricing.of_history":"av historiens lagringstid",
    "pricing.experience":"Erfaring",
    "pricing.fast_upscaling":"rask oppskalering",
    "pricing.higher_priority":"høyere prioritet",
    "pricing.early_access":"Tidlig tilgang til nye funksjoner",
    "pricing.cancel_anytime":"Avbryt når som helst",
    "pricing.lifetime_license":"Med livstidslisens kan du",
    "pricing.and_there":"Og det blir det",
    "pricing.no_expiration":"ingen utløpsdato",
    "pricing.unless":"med mindre du går tom for alle oppskalere",

    "buynow.pop.credit":"kreditt",
    "buynow.pop.credits":"studiepoeng",

    "isUnderequityTip_msg1":"Du har valgt {%} bilder for batchbehandling, og det er ikke nok gjenværende fordeler. Du trenger fortsatt {%} kreditter (for øyeblikket er det {%} kreditter igjen). Hvis du trenger å behandle, kjøp fordeler for å fortsette behandler bildene.",
    "isUnderequityTip_msg2":"Du har valgt {%} bilder for batchbehandling, og det er ikke nok gjenværende fordeler. Du trenger fortsatt {%} kreditter (for øyeblikket er det {%} bilder av fordeler igjen). Hvis du trenger å behandle, vennligst kjøp fordeler for å fortsette å behandle bildene.",
    "isUnderequityTip_msg3":"Du har valgt {%} bilder for batchbehandling, og det er ikke nok gjenværende fordeler. Du trenger fortsatt {%} kreditter (for øyeblikket er det {%} kreditter, {%} bilder av fordeler igjen), hvis du må prosess, vennligst kjøp fordeler for å fortsette å behandle bildene.",
    "btn_buy_now":"Kjøp nå",
    "isEquityDepletionTip_msg":"Dine nåværende fordeler er brukt opp. Kjøp fordelene for batchbehandling.",
}